import React, { useEffect, useState, useCallback } from "react";
import {
  CModal,
  CModalBody,
} from "@coreui/react";
import { useDispatch } from "react-redux";
import crossButton from "../../../components/assets/image/crossButton.svg";
import "../../../components/common/styles/changePassword.css";
import "../../../components/common/styles/createAdmin.css";
import { addMakeRequest } from "../redux/makeDispatcher";
import { hideAddMakeModal, showAddMakeModal } from "../redux/makeModalDispatcher";
import Select from "react-select";

const AddMake = ({
  parent_name = "__ROOT__",
  make_name = null,
  buttonLabel = "Add Make",
  editMode = false,
  makeData = {},
  categories = [],
  data = null,
  onSave = () => { }   // ✅ function parameter

}) => {
  const dispatch = useDispatch();

  const [isModalVisible, setIsModalVisible] = useState(false); // Local State
  const [makeName, setMakeName] = useState("");
  const [bodyType, setBodyType] = useState([]);
  const [availableOptionBodyType, setAvailableOprionBodyType] = useState([
    { label: "Convertible", value: "Convertible" },
    { label: "Coupe", value: "Coupe" },
    { label: "Estate", value: "Estate" },
    { label: "Hatchback", value: "Hatchback" },
    { label: "MPV", value: "MPV" },
    { label: "Pickup", value: "Pickup" },
    { label: "Saloon", value: "Saloon" },
    { label: "SUV", value: "SUV" },

    { label: "Camper", value: "Camper" },
    { label: "Car Derived Van", value: "Car Derived Van" },
    { label: "Combi Van", value: "Combi Van" },
    { label: "Minibus", value: "Minibus" },
    { label: "Panel Van", value: "Panel Van" },

    { label: "Naked", value: "Naked" },
    { label: "Adventure", value: "Adventure" },
    { label: "Super Sports", value: "Super Sports" },
    { label: "Scooter", value: "Scooter" },
    { label: "Custom Cruiser", value: "Custom Cruiser" },
    { label: "Roadster / Retro", value: "Roadster / Retro" },
    { label: "Sports Tourer", value: "Sports Tourer" },
    { label: "Tourer", value: "Tourer" },
    { label: "Bobber", value: "Bobber" },

    { label: "Beavertail", value: "Beavertail" },
    { label: "Box", value: "Box" },
    { label: "Brick Carrier", value: "Brick Carrier" },
    { label: "Bus", value: "Bus" },
    { label: "Chassis Cab", value: "Chassis Cab" },
    { label: "Coach", value: "Coach" },
    { label: "Concrete Mixer", value: "Concrete Mixer" },
    { label: "Crane Mounted", value: "Crane Mounted" },
    { label: "Curtain Side", value: "Curtain Side" },
    { label: "Dropside", value: "Dropside" },
    { label: "Flatbed", value: "Flatbed" },
    { label: "Gritter Truck", value: "Gritter Truck" },
    { label: "Hook Loader", value: "Hook Loader" },
    { label: "Livestock", value: "Livestock" },
    { label: "Low Loader", value: "Low Loader" },
    { label: "Municipal", value: "Municipal" },
    { label: "Pantechnicon", value: "Pantechnicon" },
    { label: "Road Sweeper", value: "Road Sweeper" },
    { label: "Scaffold Body", value: "Scaffold Body" },
    { label: "Skeletal", value: "Skeletal" },
    { label: "Skip Loader", value: "Skip Loader" },
    { label: "Specialist Vehicle", value: "Specialist Vehicle" },
    { label: "Tanker", value: "Tanker" },
    { label: "Temperature Controlled", value: "Temperature Controlled" },
    { label: "Tipper", value: "Tipper" },
    { label: "Tipper Grab", value: "Tipper Grab" },
    { label: "Tractor Unit", value: "Tractor Unit" },
    { label: "Vehicle Transporter", value: "Vehicle Transporter" }
  ]);


  const [selectedOptions, setSelectedOptions] = useState([]);


  const categoryOptions = React.useMemo(() => {
    if (data !== null) {
      const ids = data.category !== null ? data.category.split(',').map(Number) : [];
      return categories
        .filter(cat => ids.includes(cat.id))
        .map(cat => ({
          value: cat.id,
          label: cat.name,
        }));
    } else {
      return categories.map((cat) => ({
        value: cat.id,
        label: cat.name,
      }));
    }
  }, [data, categories]);


  const populateForm = useCallback(() => {
    console.log("make parent id", data);

    if (editMode && makeData) {
      setMakeName(makeData.name || "");
      if (makeData.body_type) {

        console.log("tesettttt:::::::", makeData.body_type);

        console.log("tesettttt:::::::", makeData.body_type.split(','));


        setAvailableOprionBodyType((prev) => {

          const newTypes = makeData.body_type
            .split(',')
            .map(item => item.trim())
            .map(item => ({ label: item, value: item }));

          const merged = [...prev, ...newTypes];

          // Remove duplicates using value
          return Array.from(
            new Map(merged.map(item => [item.value, item])).values()
          );
        });

        setBodyType(
          makeData.body_type
            .split(',')
            .map(item => item.trim())
            .map(item => ({
              label: item,
              value: item
            }))
        );
      }
      const selectedIds = makeData.category ? makeData.category.split(',').map(Number) : [];

      const mapped = categories
        .filter(cat => selectedIds.includes(cat.id))
        .map(cat => ({
          value: cat.id,
          label: cat.name,
        }));

      setSelectedOptions(mapped);
    }
  }, [editMode, makeData, categories, data]);

  useEffect(() => {
    populateForm();
  }, [populateForm]);

  const resetForm = () => {
    setMakeName("");
    setBodyType([]);
    setSelectedOptions([]);

  };



  // Handle Add Make Submission
  const handleAddMake = () => {

    if (makeName.trim() === "") {
      if (data == null) alert("Make name is required");
      else if (data?.type === "MAKE") alert("Model name is required");
      else alert("Variant name is required");
      return;
    }

    /* ---------------- DETERMINE TYPE ---------------- */

    const type =
      data == null
        ? "MAKE"
        : data?.type === "MAKE"
          ? "MODEL"
          : "VARIANT";

    /* ---------------- DETERMINE MAKE NAME ---------------- */

    let make_name_value = "";

    if (type === "MAKE") {
      make_name_value = makeName; // make itself
    }

    if (type === "MODEL") {
      make_name_value = parent_name; // parent make
    }

    if (type === "VARIANT") {
      make_name_value = data?.make_name || data?.parent_name;
      // data contains model → we need its make
    }

    /* ---------------- CATEGORY VALUE ---------------- */

    let categoryValue = null;

    if (data == null || data?.type === "MAKE") {
      categoryValue = selectedOptions.map(item => item.value).join(",");
    } else {
      categoryValue = selectedOptions?.value || null;
    }

    /* ---------------- FINAL PAYLOAD ---------------- */

    const payload = {
      name: makeName,
      parent_name: data == null ? "__ROOT__" : parent_name,
      make_name: make_name_value,
      type,
      category: categoryValue
    };

    if (bodyType) payload.body_type = bodyType.map(item => item.value).join(",");

    if (editMode) payload.id = makeData.id;

    console.log("PAYLOAD >>>", payload);
    const result = onSave();   // ✅ get return value

        console.log("PAYLOADresult >>>", result);

    dispatch(addMakeRequest(payload, parent_name, make_name, result.pageSize, result.page+1, result.searchTerm));

    setIsModalVisible(false);
    dispatch(hideAddMakeModal());
  };








  return (
    <div>
      {/* Button to Open Modal */}
      <button
        onClick={() => {
          if (!editMode) {
            resetForm(); // Reset the form if adding
          }
          setIsModalVisible(true)
          dispatch(showAddMakeModal())

        }}
        style={{
          backgroundColor: editMode === true ? "#1b87f4" : "rgb(0 0 0)",
          color: "white",
          border: "none",
          cursor: "pointer",
          borderRadius: "4px",
          fontSize: editMode === true ? "10px" : "14px",
          minWidth: "60px",
          // width: "100%",
          height: editMode === true ? "24px" : "30px",  // Increased height
          padding: editMode === true ? "2px 5px" : "4px 10px", // Added padding
          display: "flex",
          alignItems: "center",
          // alignSelf:"end",
          justifyContent: "center",
        }}
      >{buttonLabel}</button>


      <CModal
        alignment="center"
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        className="attributemodal"

      >
        <CModalBody className="main-container createAdmin" >
          <div className="main-container createAdmin">
            {/* Close Button */}
            <div className="cross-btn-div d-flex">
              <img
                onClick={() => setIsModalVisible(false)}
                src={crossButton}
                alt="close"
                className="cross-button"
              />
            </div>

            <form onSubmit={(e) => e.preventDefault()} className="login-form">
              <div className="mb-4">
                <h4
                  className="h4 fw-bold"
                  style={{ color: "#007bff", textAlign: "center" }}
                >
                  <b>{editMode === true ? (buttonLabel) : (buttonLabel)}</b>
                </h4>
              </div>



              {/* Make Name Input */}
              <div className="mb-3 input-login-box">
                <input
                  value={makeName}
                  onChange={(e) => setMakeName(e.target.value)}
                  name="name"
                  type="text"
                  className="form-control login-input"
                  placeholder={data === null ? "Enter make name" : data?.type === "MAKE" ? "Enter model name" : "Enter variant name"}
                />
              </div>


              <div className="mb-3 input-login-box">

                <Select
                  options={availableOptionBodyType}
                  isMulti={true}
                  value={bodyType}
                  onChange={setBodyType}
                  placeholder="Select body types..."
                />

              </div>




              <div className="mb-3 input-login-box">

                <Select
                  options={categoryOptions}
                  isMulti={data === null || data?.type === "MAKE"}
                  value={selectedOptions}
                  onChange={setSelectedOptions}
                  placeholder="Select categories..."
                />

              </div>




              {/* Submit Button */}
              <button
                className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
                type="button"
                onClick={handleAddMake}
              >
                {editMode ? "Update" : "Submit"}
              </button>
            </form>
          </div>
        </CModalBody>
      </CModal>
    </div>
  );
};

export default AddMake;
